import { useState } from "react";
import { fileUpload } from "../redux/services/fileUploadSlice";
import { useDispatch } from "react-redux";
import { Image } from "antd";

const ImageUpload = ({ name, setFieldValue, currentValue, handleStatementChange, index }) => {
  const [preview, setPreview] = useState(currentValue);
  const dispatch = useDispatch();

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    const response = await dispatch(fileUpload(formData));
    const url = response?.payload;
    if (name === "statement") {
      handleStatementChange(index, url);
    }

    if (url) {
      // Merge into string
      // const newValue = currentValue
      //     ? `${currentValue} || ${url}`
      //     : url;

      setFieldValue(name, url);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (name === "statement") {
      handleStatementChange(index, URL.createObjectURL(file));
    }

    setPreview(URL.createObjectURL(file));
    handleFileUpload(file);
  };

  const isImage = (value) => {
    if (!value) return false;
    try {
      const url = new URL(value);
      const ext = url.pathname.split(".").pop()?.toLowerCase();
      const imageExt = ["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"];

      return imageExt.includes(ext || "");
    } catch {
      return false;
    }
  };

  return (
    <div className="mt-3">
      <input type="file" accept="image/*" onChange={handleImageChange} className="block border w-full rounded-lg" />
      {isImage(currentValue || "") && preview && <Image width={100} height={100} src={preview} alt="Preview" className="mt-3 rounded-md " />}
    </div>
  );
};

export default ImageUpload;
